<template>
  <div :class='{menuContainer:true,hasCashier:hasCashier} '>
    <lk-menu :active-name='$route.meta.menuTitle? $route.name:$route.meta.menuNav'
    ref="menu"
    theme="dark"
    :open-names='routes'
    width='100%'
    @on-select='handleSelect'>

       <submenu :menu='menu'></submenu>

    </lk-menu>
  </div>
</template>
<script>

import submenu from './sideSubmenu.vue';

export default {
  name: 'sideMenu',
  components: {
    submenu,
  },
  computed: {
    menu() {
      return this.$store.state.app.menu;
    },
    routers() {
      return this.$store.state.app.routers;
    },
    routes() {
      return this.$route.path.split('/').slice(1);
    },
  },
  props: {
    hasCashier: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeName: '',
    };
  },
  methods: {
    resetActive() {
      console.log(this.$refs.menu);
      this.$nextTick(() => {
        this.$refs.menu.currentActiveName = this.$refs.menu.activeName;
        this.$refs.menu.updateActiveName();
      });
    },
    handleSelect(name) {
      // console.log(name);
      this.activeName = name;
      // eslint-disable-next-line array-callback-return
      // this.routers.map((val) => {
      //   if (name === val.name) {
      //     this.$store.commit('resetBreadcrumb');
      //     this.$store.commit('setBreadcrumb', val);
      //   }
      // });
    },
  },
  // mounted() {
  //   // console.log(this.routeName);
  // },
  mounted() {
    this.$nextTick(() => {
      this.handleSelect(this.$route.path.slice(this.$route.path.lastIndexOf('/') + 1));
    });
  },
};
</script>
<style  scoped>
.menuContainer{
  background:#1b1e38;
  height:calc( 100% - 63px );
}
.hasCashier{
  height:calc( 100% - 113px );
  overflow-y: auto
}
</style>
